import { render } from "./ConfirmationTable.vue?vue&type=template&id=009007c0&ts=true"
import script from "./ConfirmationTable.vue?vue&type=script&lang=ts"
export * from "./ConfirmationTable.vue?vue&type=script&lang=ts"

import "./ConfirmationTable.vue?vue&type=style&index=0&id=009007c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__